GP.GPMod('Premium',function(self){
    var vent  = null;
    var _util = null;
    var _log  = null;
    var _info = null;
    var _warn = null;

    var _conf = {
        upload_urls: {
            image: '/members/premium/upload_photo/',
            video: '/members/premium/upload_video/'
        },
        max_files_upload: 10, // maximum number of files allowed at once for uploading
        success_modal_timeout:  4000,
        trigger_viewer_success: true,
        upload_max_filesize: 1073741824 // UPLOAD_MAX_FILESIZE
    };

    var _data = {
        // default prices in credits
        price_range: {
            // min: 100,
            // max: 5000
            min: 4,
            max: 200
        },
        // Used to track if there's an image in the queue
        image_input_status: false,
        currently_fetching: false,
        can_show_progress:  false,
        max_files_reached:  false,
        media_type: null,
        override_confirm: false,
        library_tab: 'purchased',

        // local temporary var for storing the current content data while purchasing and
        // calling various other modules with callbacks so we don't have to pass it around
        tmp_content_holder: null,

        content_collection: null, // premium content backbone collection
        private_collection: null, // premium private content backbone collection

        // collection view for premium content
        premium_region: null, // premium region manager
        premium_cv: null,     // collection view for premium content
        premium_view: null,   // main region

        // collection view for premium private content
        premium_private_region: null, // premium private region manager
        premium_private_cv: null,     // collection view for premium private content
        premium_private_view: null,   // main region

        sort_type: '',
        content_type: '',
        gender_filter: '',

        start_age: 18,
        end_age: 100,

        next_page: 2,
        grid_size: 0,
        from_popstate: false,
        first_load: false,

        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            _util  = self.app.Util;

            // wrapper functions for console.log and console.info
            _info = self.app.Util.info;
            _log  = self.app.Util.log;
            _warn = self.app.Util.warn;

            // detect the File API (necessary for progressbar on upload)
            _data.can_show_progress = !!(window.File && window.FileList);
            _data.content_collection = new self.app.collections.Premium();
            _data.private_collection = new self.app.collections.Premium();  // private content

            _data.price_range = {
                // min: (GP.sdata.my_user.membership === 'BRONZE' ? 2   : 100),
                // max: (GP.sdata.my_user.membership === 'BRONZE' ? 100 : 5000)
                min: 4,
                max: 200
            };
        }
    };

    // self.content_collection = new self.app.collections.Premium();

    var gui = {
        init: function() {
            this.$btn_premium_upload          = $('#btn-premium-upload');
            this.$premium_upload_progress_bar = $('#premium-upload-progress-bar');
            this.$premium_upload_modal        = $('.premium-upload-modal');
            this.$notice_wrap                 = $('.premium-upload-modal').find('.notice-wrap');
            this.$errors_wrap                 = $('.premium-upload-errors');
            this.$success_wrap                = $('.premium-upload-modal').find('.success-wrap');
            this.$premium_region              = $('#premium-region');
            this.$premium_private_region      = $('#premium-private-region');

            // premium search stuff (content.premium)
            this.$premium_search_region       = $('#premium-search-region');
            this.$nav_filters                 = $('.premium-search-content .dropdown-menu a');
            this.$btn_sort_type               = $('.sort.dropdown .btn-sort-type');
            this.$btn_content_type            = $('.content-type.dropdown .btn-filter-type');
            this.$btn_filter_gender           = $('.gender-filter.dropdown .btn-filter-gender');
            this.$age_select_wrap             = $('.nav-filters .age-select');

            this.$sort_dropdown               = $('.sort.dropdown .dropdown-menu');
            this.$content_type_dropdown       = $('.content-type.dropdown .dropdown-menu');
            this.$gender_dropdown             = $('.gender-filter.dropdown .dropdown-menu');
            this.$sort_dropdown_text          = $('.sort.dropdown .dropdown-text');
            this.$content_type_dropdown_text  = $('.content-type.dropdown .dropdown-text');
            this.$gender_dropdown_text        = $('.gender-filter.dropdown .dropdown-text');

            this.$page_loader_wrap            = $('#page-loader-wrap');
            this.$btn_more_feed_wrap          = $('.btn-more-results-wrap');
            this.$btn_more_feed               = $('#btn-more-feed');
        }
    };

    var apis = {
        // premium search
        get_content: function(reset) {
            var post_data = {
                get_content: 1,
                sort_type: _data.sort_type,
                content_type: _data.content_type,
                gender_filter: _data.gender_filter,
                start_age: _data.start_age,
                end_age: _data.end_age
            };

            if (typeof(reset) == 'undefined') {
                reset = false;
            }

            if (!reset) {
                post_data.page = _data.next_page;
            }

            self.api.post('/members/content/premium', {
                data: post_data,
                success: function(json) {
                    events.update_feed(json, reset);
                }
            });
        },
        check_access: function(premium_content_id, callback) {
            self.api.json('premium.check_access',{
                data: { premium_content_id: premium_content_id }
            }).done(function(json) {
                if (_util.check_callable(callback)) {
                    callback(json.success);
                }
            });
        },
        purchase_content: function(json, callback) {
            // console.log('purchase_content called with json: ', json);

            var post_data = {
                premium_content_id: json.premium_content_id,
            };

            if (json.hasOwnProperty('premium_attachment')) {
                post_data.premium_attachment = true;
                post_data.media_type  = json.type;
                post_data.sender_duid = json.sender_duid;
                post_data.msg_id      = json.msg_id;
            }

            self.api.json('premium.purchase_content', {
                data: post_data
            }).done(function(json) {
                if (_util.check_callable(callback)) {
                    callback(json);
                }
            }).always(function() {
                // called after success or error and is always called
                // clear our tmp data var after this request is finished
                _data.tmp_content_holder = null;
            });
        },
        delete_content: function(model) {
            $.post('/members/premium/mod_content', {
                premium_content_id: model.get('premium_content_id'),
                action: 'USER_DELETED'
            }).done(function(json) {
                if (json.status) {
                    handlers.remove_content(model);
                }
            });
        },
        update_video_thumb: function(model, time_index) {
            self.api.json('premium.update_video_thumb',{
                data: {
                    premium_content_id: model.get('premium_content_id'),
                    time_index: time_index
                }
            }).done(function(json) {
                vent.trigger('PremiumViewerLayout:show_thumbnail_success');
            });
        }
    };

    var handlers = {
        show_content_result: function() {
            var premium_region = new Marionette.RegionManager();

            var premium_list = new self.app.views.PremiumList({
                collection: _data.content_collection,
                sort: false
            });

            premium_view = premium_region.addRegions({
                mainRegion: '#premium-region'
            });

            premium_view.mainRegion.show(premium_list);
        },
        show_private_result: function() {
            var premium_private_region = new Marionette.RegionManager();

            var premium_private_list = new self.app.views.PremiumList({
                collection: _data.private_collection,
                sort: false
            });

            premium_private_view = premium_private_region.addRegions({
                mainRegion: '#premium-private-region'
            });

            premium_private_view.mainRegion.show(premium_private_list);
        },
        show_premium_search_results: function() {
            // get a new RegionManager
            _data.premium_region = new Marionette.RegionManager();

            // set the mainRegion to the div id we want and store in _data.premium_view
            _data.premium_view = _data.premium_region.addRegions({
                mainRegion: '#premium-search-region'
            });

            // setup the collection view (PremiumList) with already setup _data.content_collection
            _data.premium_cv = new self.app.views.PremiumList({
                collection: _data.content_collection,
                sort: false
            });

            // pass the collection view to the mainRegion and show
            _data.premium_view.mainRegion.show(_data.premium_cv);
        },
        purchase_success: function(json, $el) {
             //console.warn('Premium purchase_success called with json: ', json, ' and $el: ', $el);

            _data.override_confirm = false;

            // update the model purchased attribute to trigger change:purchased
            // and rerender the collection itemview to remove lock overlay/graphic etc...
            var model = _data.content_collection.get(json.premium_content_id);
            model.set('purchased', true);
            model.set('thumb', json.thumb);

            // trigger the viewer if _conf.trigger_viewer_success is true
            if (_conf.trigger_viewer_success) {
                events.trigger_viewer_modal({
                    premium_content_id: json.premium_content_id,
                    duid: json.duid,
                    tags: json.tags
                }, $el);
            } else {
                var $success_modal = $('#premium-success-modal');

                var options = {
                    modal_div: $success_modal,
                    shown: function() {
                        setTimeout(function() {
                            vent.trigger('Modal:close');
                        }, _conf.success_modal_timeout);
                    }
                };
                GP.vent.trigger('Modal:open:static', options);
            }
        },
        remove_content: function(model) {
            var remove_pc_id = '#premium-library-media-id-' + model.get('premium_content_id');
            $(remove_pc_id).addClass('hide');

            _data.content_collection.remove(model);
            _data.private_collection.remove(model);
        }
    };

    var events = {
        init: function() {
            // vent.on('init_js:user:profile', events.init_profile);
            vent.on(self.moduleName + ':init_profile_content', events.init_profile_content);
            vent.on(self.moduleName + ':init_search_content', events.init_search_content);
            vent.on('init_js:premium:media', events.init_library);

            // vent.on(self.moduleName+":setup_upload", events.setup_upload);
            vent.on(self.moduleName+":setup_upload", events.ensure_upload_scripts);
            vent.on(self.moduleName+":empty_region", events.empty_region);
            vent.on(self.moduleName+":show_content", handlers.show_content_result);
            vent.on(self.moduleName+":show_private", handlers.show_private_result);

            vent.on(self.moduleName+":viewer", events.trigger_viewer_modal);
            vent.on(self.moduleName+":purchase", events.purchase_content);
            vent.on(self.moduleName+":delete_content", apis.delete_content);
            vent.on(self.moduleName+":update_video_thumb", apis.update_video_thumb);
            vent.on(self.moduleName+":update_content_collection", events.update_content_collection);

            // vent.on(self.moduleName+":download", apis.download);

            GP.reqres.setHandler(self.moduleName+":get_collection", function() {
                return _data.content_collection;
            });

            GP.reqres.setHandler(self.moduleName+":get_private_collection", function() {
                return _data.private_collection;
            });

            GP.reqres.setHandler(self.moduleName+":get_library_tab", function() {
                return _data.library_tab;
            });

        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();

            gui.$nav_filters.on('click', events.filter_click);
            gui.$btn_more_feed.on('click', events.load_more);
            gui.$age_select_wrap.find('select').on('change', events.update_age_range);
        },
        // populate public/private premium content collections when profile page is loaded (called from profile template)
        init_profile_content: function(premium_content, premium_private_content) {
            var prem         = [];
            var prem_private = [];

            if ((typeof premium_content != 'undefined' && premium_content.content)) {
                prem = (premium_content.content.length) ? premium_content.content : [];
            }
            if ((typeof premium_private_content != 'undefined' && premium_private_content.content)) {
                prem_private = (premium_private_content.content.length) ? premium_private_content.content : [];
            }

            // reset and populate content and private collections
            _data.tmp_content_holder = null;
            _data.override_confirm   = false;
            _data.content_collection.reset();
            _data.private_collection.reset();

            self.premium_region         = new Marionette.RegionManager();
            self.premium_private_region = new Marionette.RegionManager();

            _data.premium_cv = new self.app.views.PremiumList({
                collection: _data.content_collection,
                sort: false
            });
            _data.content_collection.add(prem);

            self.premium_view = self.premium_region.addRegions({
                mainRegion: '#premium-region'
            });
            self.premium_view.mainRegion.show(_data.premium_cv);

            if (typeof premium_private_content != 'undefined') {

                _data.premium_private_cv = new self.app.views.PremiumList({
                    collection: _data.private_collection,
                    sort: false
                });
                _data.private_collection.add(prem_private);


                self.premium_private_view = self.premium_private_region.addRegions({
                    mainRegion: '#premium-private-region'
                });
                self.premium_private_view.mainRegion.show(_data.premium_private_cv);
            }


            // render the collection view for _data.content_collection
            // _data.premium_cv.render();
            events.setup_binds();
        },
        init_library: function() {
            $('#my-library-tabs a').on('click', function(e) {
                $(this).tab('show');
                $('.library-pane').removeClass('active');

                var _tab = $(this).data('target');
                if ($(this).data('type') == 'purchased') { _data.library_tab = 'purchased'; }
                else if ($(this).data('type') == 'premium') { _data.library_tab = 'premium'; }
                else if ($(this).data('type') == 'private') { _data.library_tab = 'private'; }
                $('#' + _tab).addClass('active');
            });
        },
        init_search_content: function(premium_content_setup) {
            var prem = [];

            if ((typeof premium_content_setup != 'undefined' && premium_content_setup.content)) {
                prem = (premium_content_setup.content.length) ? premium_content_setup.content : [];
            }

            if (premium_content_setup.sort_type) {
                _data.sort_type = premium_content_setup.sort_type;
            }
            if (premium_content_setup.content_type) {
                _data.content_type = premium_content_setup.content_type;
            }
            if (premium_content_setup.gender_filter) {
                _data.gender_filter = premium_content_setup.gender_filter;
            }

            // reset and populate content collection
            _data.tmp_content_holder = null;
            _data.override_confirm   = false;

            _data.content_collection.reset(prem);

            // render the collection view for _data.content_collection
            handlers.show_premium_search_results();

            events.setup_binds();
        },
        load_more: function() {
            _data.currently_fetching = true;
            gui.$btn_more_feed.addClass('btn-loading');
            apis.get_content();
        },

        // ensure extra blueimp fileupload scripts are lazyloaded
        ensure_upload_scripts: function() {
            var local_script = '/js_v3/fu/fileupload-ui-tmpl.min.js';

            $.ajax({
                url: (_fu_ui_script_url || local_script),
                dataType: "script",
                // we can make use of cache because we already use the timestamp as part of the path
                cache: true
            }).done(function() {
                _log("fileupload-ui-tmpl.min.js loaded successfully... calling callback function");

                // setup fileupload once the ui/tmpl scripts have been loaded
                events.setup_upload();
            })
            .fail(function() {
                _log("jfileupload-ui-tmpl.min.js loading failed");
            });
        },
        setup_upload: function() {
            'use strict';

            gui.init();

            // reset the flag when initializing upload for maximum files to upload at a time
            _data.max_files_reached = false;

            if (window.can_upload_file) {
                // Initialize the jQuery File Upload widget:
                $('#fileupload').fileupload({
                    // Uncomment the following to send cross-domain cookies:
                    //xhrFields: {withCredentials: true},

                    url:              '/members/premium/upload_photo/',
                    dataType:         'json',
                    type:             'POST',
                    autoUpload:       false,
                    progressInterval: 50, // default 100ms
                    bitrateInterval:  200,

                    // limit the number of uploads at once, even though each file
                    // is sent as a separate http POST upload
                    maxNumberOfFiles: _conf.max_files_upload,

                    // Enable image preview/resizing, except for Android and Opera,
                    // which actually support image resizing, but fail to
                    // send Blob objects via XHR requests:
                    disableImageResize: /Android(?!.*Chrome)|Opera/
                        .test(window.navigator.userAgent),
                    previewMaxWidth:  200,
                    previewMaxHeight: 200,

                    // acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
                    // maxFileSize: 999000,
                    // previewCrop: true,
                    // uploadTemplateId: null,
                    // downloadTemplateId: null,

                    add: function(e, data) {
                        _info('ADD callback called... e: ', e, ' data: ', data);

                        var that = this,
                            media_type = GP.Util.check_media_type(data);

                        if (media_type === null) {
                            events.show_post_error(js_lang.unacceptable_file_type);
                            return;
                        }

                        if (typeof(data.originalFiles[0].size) !== 'undefined' && data.originalFiles[0].size > _conf.upload_max_filesize) {
                            events.show_post_error(js_lang.filesize_too_big);
                            return;
                        }

                        if (media_type == 'image') {
                            data.url = _conf.upload_urls.image;
                        } else if (media_type == 'video') {
                            data.url = _conf.upload_urls.video;
                        } else {
                            events.show_post_error(js_lang.unacceptable_file_type);
                            return;
                        }
                        // add the media_type (image or video) to the data object for use in other callbacks
                        data.media_type = media_type;

                        // enable start/upload button
                        $("#premium-upload-start").prop('disabled', false);

                        // call the original add method that was overridden since it performs necessary logic
                        $.blueimp.fileupload.prototype.options.add.call(this, e, data);

                        // add html contents of the preview column to the data object
                        // so we can replace the preview back in the 'template-download' template
                        // since the video preview won't be available from the upload/POST response like images are
                        // (this is called after processalways)
                        data.preview_col = data.context.find('td.preview-col .preview').html();

                    },
                    processfail: function(e, data) {
                        _warn('PROCESSFAIL called... e: ', e, ' data: ', data);

                        // remove the div with the preview and price input
                        data.context.remove();

                        // only need to show error at top of modal once
                        if (!_data.max_files_reached) {
                            _data.max_files_reached = true;

                            var max         = _conf.max_files_upload,
                                msg         = data.files[0].error || 'Maximum number of files exceeded',
                                error_msg   = msg + ' (max of ' + max + ' at a time)';

                            events.show_post_error(error_msg);
                            // gui.$errors_wrap.append('<p>' + error_msg + '</p>').show();
                        }
                    },
                    processalways: function(e, data) {
                        _info('PROCESSALWAYS callback called... data: ', data);

                        var $preview = $(data.context);

                        var $price_input = $($preview.find(".price-col input[name='price']")),
                            $label = $($preview.find(".price-col span.price-label"));

                        $label.text(_data.price_range.min + ' - ' + _data.price_range.max + ' credits');
                        $price_input.val(_data.price_range.min);

                        if (data.media_type == 'video' && !data.video) {
                            var icon = '<span class="glyphicon glyphicon-facetime-video" aria-hidden="true"></span>';
                            data.context.find('.preview').html(icon);
                        }
                    },
                    submit: function(e, data) {
                        var min   = _data.price_range.min,
                            max   = _data.price_range.max,
                            $start_btn = $(data.context.find(".price-col button.start")),
                            $tags_input = $(data.context.find(".price-col input[name='tags']")),
                            $price_input = $(data.context.find(".price-col select[name='price']")),
                            $caption_input = $(data.context.find(".price-col textarea[name='caption']")),
                            $premium_notify_users = $("#fileupload input[name='premium_notify_users']:checked").length,
                            price = (parseInt($price_input.val(), 10) || 0);

                        // validate price client side before submitting
                        if (price < min || price > max) {
                            var error_msg = 'Premium media prices must range between ' + min + ' - ' + max + ' credits';
                            events.show_post_error(error_msg);

                            $price_input.val('').focus();
                            $start_btn.prop('disabled', false).removeClass('hide');

                            return false;
                        }

                        if (!$caption_input.val() || $caption_input.val().length < 10) {
                            var error_msg_caption = 'Hey, we need a caption here! (At least 10 characters, please — don’t leave us hanging!)';
                            events.show_post_error(error_msg_caption);

                            $start_btn.prop('disabled', false).removeClass('hide');
                            return false;
                        }

                        data.formData = {
                            ajax_request: true,
                            process: true,
                            price_credits: price,
                            caption: $caption_input.val(),
                            premium_notify_users: $premium_notify_users
                        };
                        if (typeof $tags_input.val() != 'undefined' && $tags_input.val()) {
                            data.formData.tags = $tags_input.val();
                        }
                    },
                    send: function(e, data) {
                        _info('SEND callback called... data: ', data);

                        // unhide each file's progress bar when sending starts
                        var $progress = $(data.context.find(".preview-col .progress"));
                        $progress.removeClass('hide');

                    },
                    stopped: function(e) {
                        // all uploads are finished
                        _log('STOPPED CALLED....  e: ', e);

                        $("#btn-premium-upload-done").removeClass('hide');
                        // vent.trigger('Modal:close', 5000);
                    },
                    finished: function(e, json) {
                        _log('FINISHED CALLED....  json: ', json);

                        var content_data = {};
                        content_data = json.result.files[0];

                        if (json.media_type == 'image' && content_data && content_data.thumb) {
                            if (content_data.tags && content_data.tags.indexOf('PRIVATE') !== -1) {
                                _data.private_collection.add(content_data);
                                handlers.show_private_result();
                            } else {
                                _data.content_collection.add(content_data);
                                handlers.show_content_result();
                            }
                        } else if (json.media_type == 'video') {
                            json.context.find('td.preview-col .preview').html(json.preview_col);
                        }
                    },
                    failed: function(e, data) {
                        _warn('FAILED CALLED....  data: ', data);
                        events.show_post_error('Error with file upload');
                    }
                });
            }
        },
        show_post_error: function(error_message) {
            gui.$errors_wrap.html('<p>'+error_message+'</p>').show();
            setTimeout(function() {
                gui.$errors_wrap.fadeOut();
            }, 5000);
        },
        show_success: function() {
            gui.$success_wrap.show();
            if (_data.media_type == 'video') {
                gui.$success_wrap.addClass('success-video');
            }

            setTimeout(function() {
                gui.$success_wrap.fadeOut();
                gui.$success_wrap.removeClass('success-video');
            }, 5000);
        },
        reset_errors: function() {
            gui.$errors_wrap.empty().css('display', 'none');
        },
        empty_region: function() {
            gui.$premium_region.empty();
            gui.$premium_private_region.empty();
        },
        trigger_viewer_modal: function(data, $el) {
            if (typeof data != 'undefined' && data && data.premium_content_id) {
                vent.trigger('Modal:open', {
                    url: "/members/premium/viewer/",
                    premium_content_id: data.premium_content_id,
                    duid: data.duid,
                    tags: data.tags,
                    spinner: true
                }, $el);
            }
        },
        // 'Premium:purchase' event handler
        purchase_content: function(json, $el, success_callback) {
            // console.log('purchase_content called with json: ', json, ' and $el: ', $el);

            var _self = this,
                premium_content_id,
                content_type,
                premium_attachment,
                thread_id;

            // if this was called with no json, check if we have it in the tmp _data var and use that
            // this could happen if it was called from premium_credit_modal_closed or as a callback from mod_user_credits
            if (!json && _data.tmp_content_holder) {
                json = _data.tmp_content_holder;
                $el  = _data.tmp_content_holder.el;
                success_callback = _data.tmp_content_holder.success_callback;
            }

            if (json.hasOwnProperty('premium_content_id')) {
                premium_content_id = json.premium_content_id;
            }
            if (json.hasOwnProperty('type')) {
                content_type = json.type;
            }
            // these are passed in from thread.js when user purchases premium attachment
            if (json.hasOwnProperty('premium_attachment') && json.hasOwnProperty('thread_id')) {
                premium_attachment = json.permium_attachment;
                thread_id = json.thread_id;
            }

            // gtfo if we don't have these two
            if (!premium_content_id || !content_type) {
                return false;
            }

            // do nothing and just return if safe mode and bank compliance site
            if (GP.sdata.my_user.pg && _bank_site) {
                return;
            }

            // store the content we're trying to buy/view in a temporary var for retrival in
            // events.premium_credit_modal_closed in case we need it (backup strategy)
            _data.tmp_content_holder = json;
            _data.tmp_content_holder.el = $el;
            _data.tmp_content_holder.success_callback = success_callback;

            // check if we've already purchase this
            apis.check_access(premium_content_id, function(access_allowed) {
                // console.log('premium_purchase: check_access callback called with access_allowed: ', access_allowed);

                if (access_allowed) {
                    // open premium content viewer
                    events.trigger_viewer_modal({
                        premium_content_id: premium_content_id,
                        duid: json.duid,
                        tags: json.tags
                    }, $el);

                    // clear out tmp var for this content
                    _data.tmp_content_holder = null;
                    _data.override_confirm = false;

                } else {
                    if (GP.sdata.my_user.pg && GP.sdata.my_user.membership !== 'BRONZE') {
                        GP.vent.trigger('Modal:open', {
                            url: "/members/user/content_rating_modal/",
                            auto_trigger: true
                        });
                        return;
                    }

                    // price is only used here for the modal text.  Will always use the DB or default value for purchase
                    var price = (parseInt(json.credits, 10) || _data.price_range.min);

                    const observer = new MutationObserver((mutations, obs) => {
                        const el = document.getElementById('credits-amount');
                        if (el) {
                            el.textContent = price;
                            obs.disconnect();
                        }
                    });

                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });

                    
                    var cm_input = {
                        template: 'PREMIUM_PURCHASE',
                        sprintf: content_type.toLowerCase() + "," + price,
                        type: content_type,
                        pic_url: json.thumb,
                        override_confirm: _data.override_confirm
                    };
                    vent.trigger('Modal:open:confirm', cm_input, $.proxy(function() {
                        // check credits
                        if (!_oc && GP.sdata.my_user.credits >= price) {
                            apis.purchase_content(json, function(purchase_response) {
                                if (purchase_response.success) {
                                    // check if `success_callback` is a callable function and call it so
                                    if (_util.check_callable(success_callback)) {
                                        // clear out tmp _data vars for this content on success
                                        _data.tmp_content_holder = null;
                                        _data.override_confirm = false;

                                        success_callback(purchase_response);
                                        return;
                                    }

                                    // default success handler
                                    handlers.purchase_success(purchase_response, $el);

                                } else {
                                    // credits were not applied, show an error
                                    var error = purchase_response.error || 'purchase failed';
                                    // gui.show_error(error);
                                    alert(error);
                                }
                            });
                        } else {


                            // bind to custom event that the iframe success template will trigger
                            $('body').one('fl_credits_purchased', function(e) {
                                _oc = false;

                                // give the PB some time to update the DB and fire
                                // the mod_user_credits cometd message
                                // which should update the user's shared data (sdata)
                                setTimeout(function() {
                                    // if we have credits now, just call purchase_content again
                                    if (GP.sdata.my_user.credits > 0) {
                                        GP.vent.trigger('Modal:close');

                                        // since we're calling purchase_content again, we don't need to confirm a second time
                                        _data.override_confirm = true;
                                        events.purchase_content(json, $el, success_callback);
                                    } else {
                                        events.check_credits(_self);
                                    }
                                }, 2000);
                            });

                            // trigger modal to purchase credits if one click is available, or redirect to billing
                            if (GP.sdata.my_user.can_oneclick) {
                                // trigger modal to purchase credits
                                GP.vent.trigger('Modal:open', {
                                    url: "/members/premium/credit_modal/",
                                    spinner: true
                                }, $el);
                            } else {
                                window.location.href = GP.Util.clean_url('/members/billing/add_credits/?unlock=premium&pduid='+json.duid);
                            }

                        }
                    }, _self));
                }
            });
        },
        premium_credit_modal_closed: function(e, $modal) {
            _oc = false;
            var _self = this;
            if (typeof $modal != 'undefined' && $modal && $modal.length) {
                try {
                    var $iframe = $modal.find('iframe');

                    if ($iframe.length) {
                        var iframe_url = $iframe[0].contentWindow.location.href;
                        var re = /purchase_complete/;
                        if (re.test(iframe_url)) {
                            var new_credits = GP.sdata.my_user.credits;
                            if (new_credits > 0) {
                                events.purchase_content();
                            } else {
                                events.check_credits(_self);
                            }
                        }
                    }
                } catch (exception) {}
            }
        },
        check_credits: function(_self) {
            vent.trigger('User:check_credits', _self, function(json) {
                var new_credits = parseInt(json.credits, 10);
                if (new_credits > 0) {
                    // add toggle_priority as a callback so it fires after updating credits
                    vent.trigger('User:mod_user_credits', json, events.purchase_content, _self);
                }
            });
        },
        add_upload_preview: function(json) {
            gui.$premium_upload_modal.addClass('preview-shown');
            $("#prem-img-preview").attr('src', json.urls.M);
        },
        update_feed: function(json, reset) {

            setTimeout(function() {
                _data.currently_fetching = false;
            }, 500);

            if (typeof(reset) !== 'undefined' && reset) {
                // remove masonry, order matters.
                // $masonry_container.masonry('destroy');

                _data.content_collection.reset();
                // _data.content_collection = new self.app.collections.Content();
                // events.init_masonry();

                _data.content_collection.add(json.content);
                // handlers.show_content_result();
                handlers.show_premium_search_results();
            } else {
                _data.content_collection.add(json.content);
            }

            // Update next page number
            if (typeof(json.next_page) !== 'undefined') {
                _data.next_page = json.next_page;
            }

            events.hide_spinner();
            gui.$btn_more_feed.removeClass('btn-loading');

            // Hide load more button
            if (json.show_load_more) {
                gui.$btn_more_feed_wrap.addClass('shown');
            } else {
                gui.$btn_more_feed_wrap.removeClass('shown');
            }
        },
        update_age_range: function() {
            var $select = $(this);

            if ($select.attr('name') == 'start_age') {
                _data.start_age = parseInt($select.val(), 10);
            } else if ($select.attr('name') == 'end_age') {
                _data.end_age = parseInt($select.val(), 10);
            }

            events.filter();
        },
        filter_click: function() {
            // Set filter type
            var sort_type     = $(this).data('sort_type');
            var content_type  = $(this).data('type_filter');
            var gender_filter = $(this).data('gender_filter');

            if (sort_type) {
                _data.sort_type = sort_type;
                events.update_sort_filter();
            }
            if (content_type) {
                _data.content_type = content_type;
                events.update_content_type_filter();
            }
            if (gender_filter) {
                _data.gender_filter = gender_filter;
                events.update_gender_filter();
            }

            events.filter();
        },
        filter: function() {
            // empty region before results or Masonry plugin will having problems rendering properly.
            gui.$premium_search_region.empty();

            // show spinner while content is loading
            events.show_spinner();
            apis.get_content(true);

            // coming from popstate? Don't set the pushstate again
            if (!_data.from_popstate) {
                // var state = {
                //     premium_search: _data.filter_type
                // };
                // vent.trigger("Page:push_state", state);
            }
        },
        update_sort_filter: function() {
            var $sort_elem = gui.$btn_sort_type.filter('[data-sort_type="' + _data.sort_type + '"]');
            var sort_text = $sort_elem.data('text');

            gui.$sort_dropdown_text.text(sort_text);

            gui.$sort_dropdown.find('li').removeClass('active');
            $sort_elem.closest('li').addClass('active');
        },
        update_content_type_filter: function() {
            var $content_type_elem = gui.$btn_content_type.filter('[data-type_filter="' + _data.content_type + '"]');
            var content_type_text = $content_type_elem.data('text');

            gui.$content_type_dropdown_text.text(content_type_text);

            gui.$content_type_dropdown.find('li').removeClass('active');
            $content_type_elem.closest('li').addClass('active');
        },
        update_gender_filter: function() {
            var $gender_elem = gui.$btn_filter_gender.filter('[data-gender_filter="' + _data.gender_filter + '"]');
            var gender_text = $gender_elem.data('text');

            gui.$gender_dropdown_text.text(gender_text);

            gui.$gender_dropdown.find('li').removeClass('active');
            $gender_elem.closest('li').addClass('active');
        },
        // // used to trigger filter externally
        // trigger_filter: function(filter) {
        //     var _filter = (typeof filter == 'undefined') ? 'recent' : filter;
        //     _data.filter_type = _filter;
        //     _data.from_popstate = true;

        //     if (self.first_load) {
        //         events.filter();
        //     }
        // },
        show_spinner: function() {
            gui.$page_loader_wrap.addClass('shown');
        },
        hide_spinner: function() {
            gui.$page_loader_wrap.removeClass('shown');
        },
        update_content_collection: function(new_model) {
            _data.content_collection.each(function(model) {
                if (model.get('premium_content_id') === new_model.get('premium_content_id')) {
                    model.set('url', new_model.get('url'));
                    return false;
                }
            });
        }
    };

    this.addInitializer(function(){
        _data.init();
        events.init();

        // expose the conf object to this modules public properties for use elsewhere
        self.conf = _conf;
    });
});
